import { request } from './request'
// 获取机构合同分页列表
function getOrgContractList(data) {
    return request({
        url: '/sys/orgContract/selectListPage',
        method: 'POST',
        data: data
    })
}

//保存
function orgContractSave(data) {
    return request({
        url: '/sys/orgContract/orgContractSave',
        method: 'POST',
        data: data
    })
}

//根据合同ID查询机构合同详情
function getOrgContract(data) {
    return request({
        url: '/sys/orgContract/getOrgContract',
        method: 'POST',
        data: data
    })
}

//导出
function exportOrgContract(data) {
    return request({
        url: '/sys/orgContract/exportData',
        method: 'POST',
        responseType: 'blob',
        data: data
    })
}

//根据合同id查询是否有机构结算记录
function isExistByOrgContractId(data) {
    return request({
        url: '/sys/orgSettleRecord/isExistByOrgContractId',
        method: 'POST',
        data: data
    })
}

export default {
    getOrgContractList,
    orgContractSave,
    getOrgContract,
    exportOrgContract,
    isExistByOrgContractId
}
